import {createContext} from "react";

export const SortContext = createContext({
    asc: true,
    desc: false,
    sortBy: 'id',
    setAsc: () => {},
    setDesc: () => {},
    setSortBy: () => {}
});